
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function KabaddiRegistrationForm() {
  const bannerSrc =
    "https://png.pngtree.com/thumb_back/fh260/background/20230412/pngtree-volleyball-game-sport-flat-background-illustration-image_2269394.jpg"

  const [players, setPlayers] = useState(
    Array.from({ length: 6 }, (_, i) => ({
      no: i + 1,
      name: "",
      age: "",
      position: "",

    }))
  );
  const [substitutes, setSubstitutes] = useState(
    Array.from({ length: 2 }, (_, i) => ({
      no: i + 1,
      name: "",
      age: "",
      position: "",

    }))
  );
  const positions = [
    "Setter",
    "Outside Hitter",
    "Middle Blocker",
    "Opposite",
    "Libero",
    "Captain",
    "Vice-Captain",
  ];



  const [image, setImage] = useState(null);
  const fileInputRef = useRef(null);
  const [userId, setUserId] = useState("");
  const [teamName, setTeamName] = useState("");
  const [captainFirstName, setCaptainFirstName] = useState("");
  const [captainLastName, setCaptainLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [stateProvince, setStateProvince] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (!storedUserId) {
      console.error("No userId found in storage!");
    } else {
      console.log("Fetched userId:", storedUserId);
      setUserId(storedUserId); // store in state so we can render it
    }
  }, []);

  const handleRegister = async () => {
    if (!userId) {
      alert("User ID missing. Please login first.");
      return;
    }

    // ✅ Validate all fields before submitting
    if (
      !teamName ||
      !captainFirstName ||
      !captainLastName ||
      !email ||
      !phone ||
      !street ||
      !city ||
      !stateProvince ||
      !postalCode ||
      players.some(
        (p) => !p.no || !p.name || !p.age || !p.position
      ) ||
      substitutes.some(
        (s) => !s.no || !s.name || !s.age || !s.position
      )
    ) {
      alert("⚠️ Please fill in all fields before submitting.");
      return;
    }

    // Prepare JSON payload
    const payload = {
      userId,
      teamName,
      captainFirstName,
      captainLastName,
      players,
      substitutes,
      email,
      phone,
      address: {
        street,
        city,
        state: stateProvince,
        postalCode,
      },
      photo: image, // optional: can be base64 or URL
    };

    try {
      const res = await fetch("https://node.aattumtpl.com/api/volleyballteam/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.success) {
        alert("✅ Team registered successfully!");
        console.log("Response:", data);

        navigate("/", { replace: true });
        localStorage.removeItem("userId");
        window.scrollTo(0, 0); // 👈 forces scroll to top
      }
      else {
        alert("❌ Registration failed: " + data.message);
      }
    } catch (err) {
      console.error("Error submitting form:", err);
      alert("❌ Error submitting form. Please try again.");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file)); // create temporary preview URL
      e.target.value = null; // allow selecting same file again
    }
  };

  const handleImageClick = () => {
    // Trigger file input click when image is clicked
    fileInputRef.current.click();
  };

  const handlePlayerChange = (idx, key, value) => {
    setPlayers((prev) =>
      prev.map((p, i) =>
        i === idx ? { ...p, [key]: key === "age" ? Number(value) : value } : p
      )
    );
  };

  const handleSubChange = (idx, key, value) => {
    setSubstitutes((prev) =>
      prev.map((s, i) =>
        i === idx
          ? { ...s, [key]: key === "age" ? Number(value) : value }
          : s
      )
    );
  };


  // const emptyRowsNotice = useMemo(
  //   () => players.some((p) => !p.name || !p.age || !p.position || !p.sides),
  //   [players]
  // );

  return (
    <div className="page-wrap">
      <div className="sheet A4 portrait">
        {/* HEADER IMAGE */}
        <div className="banner">
          <img src={bannerSrc} alt="Cricket ground" />
          {/* Player cutout overlay look */}
          <div className="batsman-overlay" aria-hidden />
        </div>

        {/* BODY */}
        <div className="content">
          <h1 className="title">VOLLEYBALL TOURNAMENT</h1>
          <p className="subtitle">
            Registration Form - {userId && `(${userId})`}
          </p>

          <div className="row">
            <div className="field">
              <label>Team Name</label>
              <input
                type="text"
                value={teamName}
                onChange={(e) => setTeamName(e.target.value)}
              />
            </div>

            <div className="field two-col">
              <label className="teamname22">Team Captain / Coach Name</label>
              <div className="grid-2">
                <input
                  type="text"
                  value={captainFirstName}
                  onChange={(e) => setCaptainFirstName(e.target.value)}
                  placeholder="First Name"
                />
                <input
                  type="text"
                  value={captainLastName}
                  onChange={(e) => setCaptainLastName(e.target.value)}
                  placeholder="Last Name"
                />
              </div>
            </div>
          </div>



          <div className="field">
            <label className="teamname222">Player Details</label>
          </div>
          <div className="table-wrap">
            <table className="players">
              <thead>
                <tr>
                  <th style={{ width: 48 }}>#</th>
                  <th>Name</th>
                  <th style={{ width: 90 }}>Age</th>
                  <th style={{ width: 170 }}>Position</th>

                </tr>
              </thead>
              <tbody>
                {players.map((p, idx) => (
                  <tr key={p.no}>
                    <td>{p.no}</td>
                    <td>
                      <input
                        type="text"
                        value={p.name}
                        onChange={(e) =>
                          handlePlayerChange(idx, "name", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        min={8}
                        max={70}
                        value={p.age}
                        onChange={(e) =>
                          handlePlayerChange(idx, "age", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <select
                        value={p.position || ""}                          // ✅ use position
                        onChange={(e) => handlePlayerChange(idx, "position", e.target.value)}  // ✅ update position
                        style={{
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          backgroundImage:
                            "url(\"data:image/svg+xml;utf8,<svg fill='%23222' height='14' viewBox='0 0 24 24' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 8px center",
                          backgroundSize: "14px",
                          paddingRight: "24px",
                        }}
                      >
                        <option value=""></option>
                        {positions.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    </td>


                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="field" style={{ marginTop: "20px" }}>
            <label>Substitutes</label>
          </div>
          <div className="table-wrap">
            <table className="players">
              <thead>
                <tr>
                  <th style={{ width: 48 }}>#</th>
                  <th>Name</th>
                  <th style={{ width: 90 }}>Age</th>
                  <th style={{ width: 170 }}>Position</th>

                </tr>
              </thead>
              <tbody>
                {substitutes.map((s, idx) => (
                  <tr key={s.no}>
                    <td>S{substitutes[idx].no}</td>
                    <td>
                      <input
                        type="text"
                        value={s.name}
                        onChange={(e) => handleSubChange(idx, "name", e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        min={8}
                        max={70}
                        value={s.age}
                        onChange={(e) => handleSubChange(idx, "age", e.target.value)}
                      />
                    </td>
                    <td>
                      <select
                        value={s.position}
                        onChange={(e) => handleSubChange(idx, "position", e.target.value)}
                        style={{
                          appearance: "none",
                          WebkitAppearance: "none",
                          MozAppearance: "none",
                          backgroundImage:
                            "url(\"data:image/svg+xml;utf8,<svg fill='%23222' height='14' viewBox='0 0 24 24' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 8px center",
                          backgroundSize: "14px",
                          paddingRight: "24px",
                        }}
                      >
                        <option value=""></option>
                        {positions.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </select>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="row">
            <div className="field">
              <label>Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="example@example.com"
                required
              />
            </div>

            <div className="field">
              <label>Phone Number</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+91 00000 00000"
                pattern="^[+]91[0-9]{10}$"
                required
              />
            </div>
          </div>


          <div className="field">
            <label>Address</label>
            <input
              type="text"
              value={street}
              onChange={(e) => setStreet(e.target.value)}
              placeholder="Street Address"
              required
            />
          </div>

          <div className="row">
            <div className="field">
              <input
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                placeholder="City"
                required
              />
            </div>

            <div className="field">
              <input
                type="text"
                value={stateProvince}
                onChange={(e) => setStateProvince(e.target.value)}
                placeholder="State / Province"
                required
              />
            </div>
          </div>

          <div className="field">
            <input
              type="text"
              value={postalCode}
              onChange={(e) => setPostalCode(e.target.value)}
              placeholder="Postal / Zip Code"
              required
            />
          </div>


          <div className="field">
            <label>Upload Photo</label>
            <div className="drop">
              <input
                type="file"
                className="file-input"
                onChange={handleFileChange}
                ref={fileInputRef}
                accept="image/*"
              />
              {image ? (
                <img
                  src={image}
                  alt="Preview"
                  className="preview-image"
                  onClick={handleImageClick} // click image to select new file
                  style={{ cursor: "pointer" }}
                />
              ) : (
                <div
                  className="drop-inner"
                  onClick={() => fileInputRef.current.click()}
                  style={{ cursor: "pointer" }}
                >
                  <div className="cloud" aria-hidden />
                  <strong>Browse Files</strong>
                  <span>Drag and drop files here</span>
                </div>
              )}
            </div>
          </div>


          <div className="actions">
            <button className="btn" onClick={handleRegister}>
              Register
            </button>
          </div>

        </div>
      </div>

      <style>{`
        /* ---------- PAGE LAYOUT ---------- */
        :root {
          --theme: #f3f3f3ff; /* purple background */
          --ink: #264653;
          --line: #d1e0ea;
          --accent: #0d47a1;
        }
        * { box-sizing: border-box; }
        html, body, #root { height: 100%; }
        body { margin: 0; background: var(--theme); font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Apple Color Emoji', 'Segoe UI Emoji'; color: var(--ink); margin-top: 100px;}
        .page-wrap { padding: 24px; display: grid; place-items: center; }
        .sheet { width: 210mm; min-height: 297mm; background: #fff; border-radius: 5px;  overflow: hidden; }
        .content { padding: 18mm 16mm 20mm; }

        /* ---------- HEADER ---------- */
        .banner { position: relative; height: 62mm; overflow: hidden; }
        .banner img { width: 100%; height: 100%; object-fit: cover; display:block; filter: saturate(1.05); }
        .batsman-overlay { position: absolute; right: 16mm; bottom: -6mm; width: 95mm; height: 95mm;  mask-image: radial-gradient(55% 55% at 60% 35%, black 40%, transparent 60%); pointer-events: none; }

        /* ---------- TYPOGRAPHY ---------- */
        .title { margin: -30px 0 2mm; text-align: center; letter-spacing: .06em; color: #31647b; font-weight: 700; font-size: 8mm; }
        .subtitle { margin: 0 0 8mm; text-align: center; color: #64748b; font-size: 4mm; }
       

        /* ---------- FORMS ---------- */
        .row { display: grid; grid-template-columns: 1fr 1fr; gap: 6mm; }
        .row + .row { margin-top: 4mm; }
        .field { display: flex; flex-direction: column; gap: 1.5mm; margin-bottom: 4mm; }
        .field.two-col { margin-bottom: 0; }
        .field label { font-size: 3.5mm; color: #475569; margin-bottom: 1mm; }
     
        .grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 2mm; }
        input[type="text"], input[type="email"], input[type="number"], input[type="tel"], select { height: 11mm; border: 1px solid #c3d4e6; border-radius: 1.5mm; padding: 0 4mm; font-size: 3.8mm; outline: none; transition: border .2s ease; }
        input:focus, select:focus { border-color: #7aa7c7; box-shadow: 0 0 0 2px rgba(56, 189, 248, .15); }
        small { color: #94a3b8; }

        /* ---------- TABLE ---------- */
        .table-wrap { border: 1px solid var(--line); border-radius: 2mm; overflow: hidden; margin-bottom: 20px; }
        table.players { width: 100%; border-collapse: collapse; font-size: 3.7mm; }
        .players thead th { background: #f0f6fb; text-align: center; padding: 3.5mm; border-bottom: 1px solid var(--line); color: #334155; font-weight: 600; }
        .players tbody td { padding: 2.5mm; border-bottom: 1px solid #e8f0f7; }
        .players tbody tr:last-child td { border-bottom: none; }
        .players tbody input, .players tbody select { width: 100%; height: 10mm; margin-top: 10px;}
        .players tbody td:first-child { text-align: center; color: #475569; }

        /* ---------- UPLOAD ---------- */
       .drop {
  position: relative;
  border: 1.5px dashed #cbd5e1;
  border-radius: 1.5mm;
  width: 100%;        /* or max-width: 200px */
  max-width: 173mm;   /* optional max width */
  height: 50mm;       /* adjusted drop area */
  display: grid;
  place-items: center;
  overflow: hidden;   /* ensures image doesn’t overflow */
}

.file-input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.drop-inner {
  text-align: center;
  display: grid;
  gap: 1mm;
}

.cloud {
  width: 40px;
  height: 40px;
  margin: 0 auto 8px auto; /* center above text */
  background: url("data:image/svg+xml;utf8,<svg fill='%23cc3366' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M19.35 10.04c-.68-3.59-4.08-6.04-7.76-5.26-2.41.48-4.31 2.39-4.79 4.8C4.57 10.16 3 12.03 3 14.25 3 16.73 5.02 18.75 7.5 18.75h11c2.21 0 4-1.79 4-4 0-1.93-1.37-3.57-3.15-3.96zM12 12v4m0-4l-2 2m2-2l2 2' stroke='%23888' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>") no-repeat center;
  background-size: contain;
}


.drop-inner strong {
  font-weight: 700;
}

.drop-inner span {
  color: #94a3b8;
  font-size: 3.5mm;
}

.preview-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;   /* show full image without cropping */
  border-radius: 1.5mm;
  background: #f0f0f0;   /* optional background */
}



        /* ---------- ACTIONS ---------- */
        .actions {   display: flex;  align-items: center; gap: 6mm; margin-top: 6mm;  justify-content: center;}
        .btn { background: #007BFF; color: #fff; border: none; border-radius: 1.5mm;  height: 12mm; font-size: 13px; cursor: pointer; width: 120px; align-items: center; text-align: center;  justify-content: center;}
        .btn:hover { filter: brightness(1.05); }


        /* ---------- PRINT ---------- */
        @page { size: A4 portrait; margin: 0; }
        @media print {
          body { background: #fff; }
          .page-wrap { padding: 0; }
          .sheet { width: 210mm; min-height: 297mm; box-shadow: none; border-radius: 0; }
          .btn, .hint { display: none !important; }
        }

             /* ---------- 📱 MOBILE VIEW ---------- */
@media screen and (max-width: 768px) {
  /* Page layout */
  .page-wrap {
    padding: 12px;
  }

  .sheet {
    width: 100%;
    min-height: auto;
    border-radius: 0;
  }

  .content {
    padding: 16px 12px 24px;
  }

  /* Header and titles */
  .title {
    font-size: 22px;
    margin-top: 10px;
  }

  .subtitle {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .banner {
    height: 160px;
  }

  /* Form rows */
  .row {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .field {
    width: 100%;
    margin-bottom: 16px;
  }

  .field label {
    font-size: 14px;
    
  }
  .teamname22{
  margin-top: -15px;
  }
  .teamname222{
  margin-top: 20px;
 
  }

  input[type="text"],
  input[type="email"],
  input[type="number"],
  input[type="tel"],
  select {
    width: 100%;
    height: 44px;
    font-size: 15px;
    border-radius: 6px;
    padding: 0 12px;
  }

  /* Upload section */
  .drop {
    width: 100%;
    height: 160px;
    max-width: 100%;
    border-radius: 6px;
  }

  .cloud {
    width: 30px;
    height: 30px;
  }

  .drop-inner span {
    font-size: 13px;
  }

  /* Table */
  .table-wrap {
    overflow-x: auto;
  }

  table.players {
    font-size: 13px;
    width: 100%;
  }

  .players tbody input,
  .players tbody select {
    height: 30px;
    margin-top: 6px;
    font-size: 13px;
  }

  /* Buttons */
  .actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 20px;
  }

  .btn {
    width: 100%;
    max-width: 180px;
    height: 46px;
    font-size: 15px;
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
  }

}
@media screen and (max-width: 768px) {
  table.players thead th:nth-child(1) { width: 30px; }  /* # */
  table.players thead th:nth-child(2) { width: 140px; } /* Name */
  table.players thead th:nth-child(3) { width: 60px; }  /* Age */
  table.players thead th:nth-child(4) { width: 120px; } /* Position */
  table.players thead th:nth-child(5) { width: 80px; }  /* Arm */

  table.players {
    font-size: 13px;
  }
}

      `}</style>
    </div>
  );
}
